export class Session
{
  constructor() { }
  isNew: boolean = true;
    sessionType: any = null;
    sessionFormat: any = null;
  companyName: any = null;
    clientProgram: any = null;
    sessionCountry: any = null;
    sessionCity: any = null;
    sessionState: any = null;
    sessionCoordinators: any = null;
  responsiblePpmd: any = null;
  responsiblePpmdemail: string = '';
    serviceLineFunction: any = null;
    sessionIndustry: any = null;
    sessionSector: any = null;
    sessionDepartment: any = null;
    otherDepartment: string;
    ppmd: any = null;
  nonPpmd: any = null;
  executives: any = null;
  secRestricted: any = null;
  sessionRequester: string;
  nonExecutives: any = null;
  sessionDate: any = null;
  sessionTime: any = null;
  sessionTimezone: any = null;
  sessionName: string;
  certifiedFacilitator: any = null;
    linkExpire: any = null;
    wbsPrdCode: string;
    sessionParticipantManager: string;
  sessionComments: string;
  showsession: boolean = false;
  countryid: number = 0;
  stateid: number = 0;
  serviefunctionid: number = 0;
  industryid: number = 0;
  sectorid: number = 0;
  departmentid: number = 0;
  ClientProgramID: number = 0;
    SecRestrictionID: number = 0;
    sessionTypes: any = null;
    explainRationale: any = null;
    sessionTypeSpecify: any = null;
    domainInfo: any = null;
    participantEmailInfo: any = null;
    clientEmailInfo: any = null;
    sponsoredCountry: any = null;
    sessionLink: any = null;
    sessionTypesEvent: any = null;
    sessionTypesProgram: any = null;
    proBono: any = null;
    lastModifiedDate: any = null
    gxFees: any = null;
    subscriptionId: any = null;
    sessionSubTypes: any = null;
    approvalStatus: any = 'New';
    serviceLineNA: any = null;
    industryNA: any = null;
    sectorNA: any = null;
    nonDelProfessional: any = null;
    actualUsage: any = 0;
    sessionReport: any = null;
    cSuite: boolean = false;
    reportCheck: boolean = false;
    overageWBS: any = 0;
    currencyType: any = 4;
    rate: any = null;
    reason: string = '';
    surcharge: any = null;
    approvalDate: Date = null;
    cadenceDate: Date = null;
    displayName: string = '';
    UserRoles: any[] = [];
    disableSFDCIntegration: boolean = false;
    sfdcDisableReasonId: any = null;
    sfdcDisableOtherReason: string = null;
    contentArea: number = null;
    Topic: number = null;

}
